import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { ICON_TYPE } from '../../icon/icon.constants';
import { middle } from '../../utils/sizes';
import { makeDefaultStylingContext } from '../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const ARROW_SIZE = {
  [HD]: 56,
  [FULL_HD]: 80,
};

export const getInitialStyle = ({ screenSize } = defaultContext) => ({
  Up: {
    mountX: 0.5,
    x: middle,
    y: 0,
    iconData: {
      picto: {
        name: 'ArrowUp',
        type: ICON_TYPE.SIMPLE_ICON,
      },
      viewBox: {
        h: ARROW_SIZE[screenSize],
      },
    },
  },
  Pane: {},
  Down: {
    mountX: 0.5,
    mountY: 1,
    x: middle,
    iconData: {
      picto: {
        name: 'ArrowDown',
        type: ICON_TYPE.SIMPLE_ICON,
      },
      viewBox: {
        h: ARROW_SIZE[screenSize],
      },
    },
  },
});
